<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader :title="$t('account_settings_legal.tax_situation')" :icon="UsersIcon"></WizardHeader>
            <div class="px-4 py-3 sm:px-6">
                <LegalTaxInformationForm v-model="formValues"></LegalTaxInformationForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :loading="usePersonalAccountDataState().saving"
                :disabled="
                    usePersonalAccountDataState().saving || formState.hasValidationErrors || !areTaxRecidenciesValid
                "
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                Please confirm the Entity’s tax situation, and the countries of which it is a tax resident.
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { TaxResidency, usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import { TaxSituationAndResidencies } from './form/forms'
import LegalTaxInformationForm from './form/LegalTaxInformationForm.vue'
import { computed } from 'vue'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab, navigateToTab } = inject('navigation')

const formValues = ref(new TaxSituationAndResidencies())

onMounted(() => {
    formValues.value.tax_residencies = Object.assign([], useLegalAccountDataState().legalProfile.tax_residencies)

    if (useLegalAccountDataState().legalProfile.compliance_profiles.esac) {
        formValues.value.tax_situation =
            useLegalAccountDataState().legalProfile.compliance_profiles.esac.tax_situation.tax_situation
    }

    if (formValues.value.tax_residencies.length === 0) {
        formValues.value.tax_residencies.push(new TaxResidency())
    }
})

const areTaxRecidenciesValid = computed(() => {
    return formValues.value.tax_residencies.every((taxResidency) => {
        return taxResidency.country && (taxResidency.tin || taxResidency.no_tin_reason)
    })
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        useLegalAccountDataState().legalProfile.compliance_profiles.esac.tax_situation.tax_situation =
            formValues.value.tax_situation
        useLegalAccountDataState().legalProfile.tax_residencies = formValues.value.tax_residencies
        await formState.submit()
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
